<div class="app-container">
  <page-header [title]="'dashboard'" [icon]="'fa-chart-pie'" [fullWidthPageTitle]="true"></page-header>

  <loading-spinner [isLoading]="queryCheckouts.isPending()" [classesString]="'top-50'"></loading-spinner>
  @if (!queryCheckouts.isLoading() && !queryCheckouts.isPending() && !queryCheckouts.isFetching()) {
    <section class="content">
      @if (isChartsPermitted()) {
        <div class="row">
          @if (queryCheckouts.data() && queryCheckouts.data()?.length > 0) {
            @for (checkout of queryCheckouts.data(); track checkout) {
              <div class="col-12 col-lg-6">
                <app-charts-stats-checkout [checkout]="checkout"></app-charts-stats-checkout>
              </div>
            }
          }
          @if (!queryCheckouts.data()?.length) {
            <section class="content max-width-80">
              {{ 'home.no-checkouts' | translate }}
            </section>
          }
        </div>
      }
    </section>
  }
</div>
